import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SignedMetadataFirmware {
  file_path: string;
  signature: string;
  file_size: number;
  file_name: string;
}

export interface SignedMetadataRecord {
  model: string;
  signed_at: string;
  description: string;
  sign_metadata: {
    mb?: SignedMetadataFirmware;
    wifi?: SignedMetadataFirmware;
  };
}

export interface OtaModelSelectionDialogData {
  selectedModel: string;
  details: SignedMetadataRecord[];
}

export interface OtaModelSelectionDialogResult {
  action: 'accept' | 'discard' | 'close';
  selectedRecord?: SignedMetadataRecord;
}

@Component({
  selector: 'app-ota-model-selection-dialog',
  templateUrl: './ota-model-selection-dialog.component.html',
  styleUrls: ['./ota-model-selection-dialog.component.css']
})
export class OtaModelSelectionDialogComponent {
  selectedRecord: SignedMetadataRecord | null = null;

  constructor(
    public dialogRef: MatDialogRef<OtaModelSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OtaModelSelectionDialogData
  ) {}

  close(action: OtaModelSelectionDialogResult['action']): void {
    this.dialogRef.close({ action });
  }

  selectRecord(record: SignedMetadataRecord): void {
    this.selectedRecord = record;
  }

  isSelected(record: SignedMetadataRecord): boolean {
    return this.selectedRecord === record;
  }

  acceptSelection(): void {
    if (!this.selectedRecord) {
      return;
    }

    this.dialogRef.close({
      action: 'accept',
      selectedRecord: this.selectedRecord
    });
  }

  formatSignedAt(value: string): string {
    return value ? new Date(value).toLocaleString() : '-';
  }

  formatFileSize(value?: number): string {
    return value != null ? value.toLocaleString() : '-';
  }
}
